import React, {Component} from 'react';
import {Link, Switch, Route, Redirect } from 'react-router-dom';
import {withRouter} from 'react-router';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Footer from '../../components/Footer/';
import { connect } from 'react-redux'
import Dashboard from '../../views/Dashboard/';

import Clients from '../../views/Clients/';
import AddressesOverview from '../../views/Addresses/';
import ViewAddress from '../../views/Addresses/view';

import Account from '../../components/Account';

import AddFileType from '../../views/Filetype/form';
import FileType from '../../views/Filetype';

import AddFileMetaDataCategory from '../../views/Filemetadatacategory/Form';
import FileMetaDataCategory from '../../views/Filemetadatacategory';

import AddFileMetaDataValue from '../../views/Filemetadatavalue/form';
import FileMetaDataValue from '../../views/Filemetadatavalue';


import Files from '../../views/Files';

import AddFrontEndUser from '../../views/User/form';
import FrontEndUser from '../../views/User';

import AddReport from '../../views/Report/form';
import AddGlobalReport from '../../views/Report/globalForm';
import ReportOverview from '../../views/Report/Overview';

import Messages from '../../views/Messages/Overview';

class Full extends Component {
  render() {

    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">

            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route exact path="/dashboard/" name="Dashboard" render={(location) => <Dashboard />}/>
                <Route path="/clients/" name="Clients" render={(location) => <Clients />}/>
                <Route exact path="/addresses/" name="Clients" render={(location) => <AddressesOverview />}/>
                <Route path="/addresses/view/:addressId" name="Addresses" render={(location) => <ViewAddress />}/>

                <Route path="/account/" name="Clients" render={(location) => <Account />}/>
                <Route path="/files" name="Files" render={(location) => <Files />}/>
                <Route path="/filetype/add" name="Add filetype" render={(location) => <AddFileType />}/>
                <Route path="/filetype/update/:categoryid" name="Add filetype" render={(location) => <AddFileType />}/>
                <Route path="/filetype/view" name="Filetype overview" render={(location) => <FileType />}/>
                <Route path="/filemetadatacategory/add" name="Add file metadata" render={(location) => <AddFileMetaDataCategory />}/>
                <Route path="/filemetadatacategory/update/:categoryid" name="Add file metadata" render={(location) => <AddFileMetaDataCategory />}/>
                <Route path="/filemetadatacategory/view" name="File metadata overview" render={(location) => <FileMetaDataCategory />}/>
                <Route path="/filemetadatavalue/add" name="Add file metadata" render={(location) => <AddFileMetaDataValue />}/>
                <Route path="/filemetadatavalue/update/:categoryid" name="Add file metadata" render={(location) => <AddFileMetaDataValue />}/>
                <Route path="/filemetadatavalue/view" name="File metadata overview" render={(location) => <FileMetaDataValue />}/>
                <Route path="/user/add" name="Add user" render={(location) => <AddFrontEndUser />}/>
                <Route path="/user/update/:userId" name="Add file metadata" render={(location) => <AddFrontEndUser />}/>
                <Route path="/user/view" name="User overview" render={(location) => <FrontEndUser />}/>
                <Route key={"add"} path="/report/add" name="Add report" render={(location) => <AddReport />}/>
                <Route path="/report/view" name="View report" render={(location) => <ReportOverview />}/>
                <Route key={"update"} path="/report/update/:reportId" name="Update report" render={(location) => <AddReport />}/>
                <Route key={"addGlobal"} path="/report/addGlobal" name="Add report" render={(location) => <AddGlobalReport />}/>
                <Route key={"update"} path="/report/updateGlobal/:reportId" name="Add report" render={(location) => <AddGlobalReport />}/>
                <Route path="/messages" name="Messages" render={(location) => <Messages />}/>
                <Redirect from="/" to="clients" />
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer
    }
}

export default withRouter(connect(mapStateToProps)(Full))



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js